(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tg-currency-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const select = event.target;
    if (select instanceof HTMLSelectElement && select.matches('[data-tg-currency]')) {
      select.form?.requestSubmit();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tg-product-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('tg-product-gallery'))customElements.define('tg-product-gallery',class extends HTMLElement{
 connectedCallback(){
  if(this.events)return;
  this.events=new AbortController();const signal=this.events.signal;
  this.track=this.querySelector('.tg-product-gallery__track');
  this.slides=[...this.querySelectorAll('[data-gallery-media]')];
  this.rail=this.querySelector('.tg-product-gallery__thumbs');
  this.thumbs=[...this.querySelectorAll('[data-gallery-target]')];
  this.index=0;
  this.addEventListener('click',event=>{
   if(this.dragged){event.preventDefault();event.stopPropagation();return}
   const thumb=event.target.closest('[data-gallery-target]');
   if(thumb){event.preventDefault();this.selectMedia(thumb.dataset.galleryTarget)}
   const step=event.target.closest('[data-gallery-step]');
   if(step)this.selectIndex(this.index+Number(step.dataset.galleryStep));
   const railStep=event.target.closest('[data-gallery-rail-step]');
   if(railStep)this.rail.scrollBy({left:Number(railStep.dataset.galleryRailStep)*this.rail.clientWidth*.8,behavior:this.motion()});
  },{signal});
  this.addEventListener('keydown',event=>{
   const thumb=event.target.closest('[data-gallery-target]');
   if(event.target!==this.track&&!thumb)return;
   const index=thumb?this.thumbs.indexOf(thumb):this.index;
   const next={ArrowLeft:index-1,ArrowRight:index+1,Home:0,End:this.slides.length-1}[event.key];
   if(next===undefined)return;
   event.preventDefault();this.selectIndex(next);
   if(thumb)this.thumbs[this.index].focus({preventScroll:true});
  },{signal});
  this.track.addEventListener('scroll',()=>{clearTimeout(this.settleTimer);this.settleTimer=setTimeout(()=>this.settle(),120)},{passive:true,signal});
  this.track.addEventListener('scrollend',()=>this.settle(),{signal});
  this.rail?.addEventListener('scroll',()=>this.syncRail(),{passive:true,signal});
  this.rail?.addEventListener('wheel',event=>{
   if(event.ctrlKey||Math.abs(event.deltaX)>=Math.abs(event.deltaY))return;
   const delta=event.deltaY*(event.deltaMode===1?16:event.deltaMode===2?this.rail.clientWidth:1);
   const next=Math.max(0,Math.min(this.rail.scrollLeft+delta,this.rail.scrollWidth-this.rail.clientWidth));
   if(Math.abs(next-this.rail.scrollLeft)<1)return;
   event.preventDefault();this.rail.scrollLeft=next;
  },{passive:false,signal});
  [this.track,this.rail].filter(Boolean).forEach(track=>this.enableDrag(track,signal));
  this.resize=new ResizeObserver(()=>{this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:'instant'});this.syncRail()});this.resize.observe(this.track);
  this.videoVisibility = new Map();
  this.videoObserver = new IntersectionObserver(entries=>{entries.forEach(entry=>this.videoVisibility.set(entry.target,entry.intersectionRatio>=.5));this.syncVideo()},{threshold:[0,.5,1]});
  this.querySelectorAll('video').forEach(video=>this.observeVideo(video));
  this.mediaObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)this.hydrateMedia(entry.target)}),{root:this.track,threshold:.01});
  this.slides.forEach(slide=>this.mediaObserver.observe(slide));
  document.addEventListener('visibilitychange',()=>this.syncVideo(),{signal});
  this.addEventListener('pointerup',()=>this.syncVideo(),{signal});
  const hashSlide=this.slides.find(slide=>'#'+slide.id===location.hash);
  this.selectMedia(hashSlide?.dataset.galleryMedia||this.dataset.initialMedia,'instant');
 }
 disconnectedCallback(){this.events?.abort();this.events=null;this.resize?.disconnect();this.videoObserver?.disconnect();this.mediaObserver?.disconnect();clearTimeout(this.settleTimer);clearTimeout(this.dragTimer);this.slides?.forEach(slide=>slide.querySelectorAll('video').forEach(v=>v.pause()))}
 motion(){return matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}
 selectMedia(id,behavior=this.motion()){const index=this.slides.findIndex(s=>s.dataset.galleryMedia===String(id));if(index>=0)this.selectIndex(index,behavior)}
 selectIndex(index,behavior=this.motion()){
  this.setActive(Math.max(0,Math.min(index,this.slides.length-1)));
  this.track.scrollTo({left:this.index*this.track.clientWidth,behavior});
 }
 setActive(index){
  if(!this.slides[index])return;this.hydrateMedia(this.slides[index]);this.index=index;
  this.slides.forEach((slide,i)=>{const active=i===index;slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));slide.querySelectorAll('video').forEach(v=>{if(!active)v.pause()})});
  this.thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-current',String(i===index)));
  this.querySelectorAll('[data-gallery-step]').forEach(button=>button.disabled=Number(button.dataset.galleryStep)<0?index===0:index===this.slides.length-1);
  const thumb=this.thumbs[index];if(thumb){const box=thumb.getBoundingClientRect(),bounds=this.rail.getBoundingClientRect();if(box.left<bounds.left)this.rail.scrollLeft+=box.left-bounds.left;else if(box.right>bounds.right)this.rail.scrollLeft+=box.right-bounds.right}
  this.syncRail();this.syncVideo();
 }
 observeVideo(video){video.controls=false;video.muted=true;video.defaultMuted=true;video.loop=true;video.playsInline=true;this.videoObserver?.observe(video)}
 hydrateMedia(slide){const template=slide.querySelector('template[data-gallery-content]');if(!template)return;slide.querySelector('.tg-gallery-media-placeholder')?.remove();template.replaceWith(template.content.cloneNode(true));slide.querySelectorAll('video').forEach(video=>this.observeVideo(video))}
 syncVideo(){this.slides.forEach((slide,index)=>slide.querySelectorAll('video').forEach(video=>{if(index===this.index&&this.videoVisibility?.get(video)&&!document.hidden){video.play().catch(()=>{})}else video.pause()}))}
 settle(){clearTimeout(this.settleTimer);if(this.track.clientWidth&&!this.track.classList.contains('is-dragging'))this.setActive(Math.round(this.track.scrollLeft/this.track.clientWidth))}
 syncRail(){if(!this.rail)return;this.querySelectorAll('[data-gallery-rail-step]').forEach(button=>button.disabled=Number(button.dataset.galleryRailStep)<0?this.rail.scrollLeft<=1:this.rail.scrollLeft>=this.rail.scrollWidth-this.rail.clientWidth-1)}
 enableDrag(track,signal){
  let drag;
  track.addEventListener('dragstart',event=>{if(event.target.tagName==='IMG')event.preventDefault()},{signal});
  track.addEventListener('pointerdown',event=>{
   if(event.pointerType!=='mouse'||event.button!==0||event.target.closest('video,iframe,model-viewer'))return;
   clearTimeout(this.dragTimer);this.dragged=false;
   drag={id:event.pointerId,x:event.clientX,y:event.clientY,left:track.scrollLeft,active:false};
  },{signal});
  track.addEventListener('pointermove',event=>{
   if(!drag||event.pointerId!==drag.id||!(event.buttons&1))return;
   const dx=event.clientX-drag.x,dy=event.clientY-drag.y;
   if(!drag.active){if(Math.abs(dx)<6||Math.abs(dx)<=Math.abs(dy))return;drag.active=true;track.setPointerCapture(event.pointerId);track.style.scrollSnapType='none';track.classList.add('is-dragging')}
   event.preventDefault();track.scrollLeft=drag.left-dx;
  },{signal});
  const finish=()=>{
   if(!drag)return;const active=drag.active;drag=null;
   track.style.scrollSnapType='';track.classList.remove('is-dragging');
   if(active){this.dragged=true;clearTimeout(this.dragTimer);this.dragTimer=setTimeout(()=>{this.dragged=false},0);if(track===this.track)this.selectIndex(Math.round(track.scrollLeft/track.clientWidth))}
  };
  track.addEventListener('pointerup',finish,{signal});track.addEventListener('pointercancel',finish,{signal});track.addEventListener('lostpointercapture',finish,{signal});
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tg-quantity-gift-bundles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tg-bundle-gifts')) {
    customElements.define('tg-bundle-gifts', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', event => {
          const opener = event.target.closest('[data-gift-open]');
          if (opener) {
            const dialog = document.getElementById(opener.getAttribute('aria-controls'));
            if (dialog && this.contains(dialog)) dialog.showModal();
            return;
          }
          const close = event.target.closest('[data-gift-close]');
          if (close) close.closest('dialog').close();
          if (event.target.matches('dialog')) {
            const rect = event.target.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
